import axios from '@/axiosInterceptor';

const state = () => ({
  savedContacts: {
    dispatch: null,
    billing: null,
    claims: null,
    after_hours: null,
    emergency: null,
    owner: null,
  },
  contactIsTypes: [
    'dispatch',
    'billing',
    'claims',
    'after_hours',
    'emergency',
    'owner',
  ],
  requiredContactIsTypes: ['dispatch', 'billing', 'claims'],
  errors: {
    name: false,
    phone: false,
    email: false,
  },
  requiredContactsCompleted: false,
  allContacts: {
    dispatch: [],
    billing: [],
    claims: [],
    after_hours: [],
    emergency: [],
    owner: [],
  },
  dispatch_contacts: [],
  billing_contacts: [],
  claims_contacts: [],
  after_hours_contacts: [],
  emergency_contacts: [],
  owner_contacts: [],
  isContactsLoading: false,
  contactsPagination: {
    dispatch: {
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
    },
    billing: {
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
    },
    claims: {
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
    },
    after_hours: {
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
    },
    emergency: {
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
    },
    owner: {
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
    },
  },
  contactsLoading: {
    dispatch: false,
    billing: false,
    claims: false,
    after_hours: false,
    emergency: false,
    owner: false,
  },
});

// getters
const getters = {};

// actions
const actions = {
  async getContactsByCarrierId(
    { commit, state, dispatch },
    { page = 1, perPage = 50, carrierId, nameQuery } = {}
  ) {
    commit('setContactsLoading', true);

    try {
      const params = {
        'q[carrier_id_eq]': carrierId,
        '[id_gteq]': 1,
        page,
        per_page: perPage,
        'q[s]': 'id desc',
        ...(nameQuery ? { 'q[name_cont]': nameQuery } : {}),
      };
      const res = await axios.get(
        process.env.API_MONITOR + '/api/v1/contacts',
        { params }
      );
      commit('setContacts', res.data);

      const allContacts = res.data || [];

      state.contactIsTypes.forEach((t) => {
        const contact = allContacts.find((el) => el.is_type === t);
        if (contact) {
          commit('setSavedContact', { data: contact, is_type: t });
        }
      });
      dispatch('checkRequiredComplete');

      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e.response.status)) {
        return e.response;
      } else {
        throw e;
      }
    } finally {
      commit('setContactsLoading', false);
    }
  },
  async getContactsByType(
    { commit },
    { page = 1, perPage = 50, carrierId, type = 'dispatch' } = {}
  ) {
    commit('setContactTypeLoading', { bool: true, type });

    try {
      const params = {
        'q[carrier_id_eq]': carrierId,
        '[id_gteq]': 1,
        page,
        per_page: perPage,
        'q[s]': 'id desc',
        'q[is_type_eq]': type,
      };
      const res = await axios.get(
        process.env.API_MONITOR + '/api/v1/contacts',
        { params }
      );

      commit('setContactsPagination', {
        data: {
          totalRecords: res.headers?.totalitems,
          totalPages: res.headers?.totalpages,
          currentPage: res.headers?.currentpage,
        },
        type,
      });

      await commit('setAllContacts', { data: res.data, is_type: type });
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e.response.status)) {
        return e.response;
      } else {
        throw e;
      }
    } finally {
      commit('setContactTypeLoading', { bool: false, type });
    }
  },
  // async createContactByType({ commit }, data) {
  //   let body = {
  //     "contact": data
  //   }
  //   // let formData = new FormData();
  //   // formData.append('dispatcher_connection[carrier_id]', body.carrier_id);
  //   try {
  //       let res = await axios.post(process.env.API_MONITOR + "/api/v1/contacts", body)
  //       if (res && res?.data) {
  //         commit("setSavedContactByType", { data: res?.data, is_type: res?.data?.is_type })
  //       }
  //       return res;
  //   } catch (e) {
  //       let status = e.response?.status
  //       if (axios.isAxiosError(e) && status && [401, 403, 404, 422].includes(status)) {
  //           return e.response
  //       } else {
  //           throw e
  //       }
  //   }
  // },

  // Set all contacts from initial Identity contact values based on is_type
  async initializeContacts({ dispatch, state, commit }, data) {
    let allContacts = data?.contacts;
    let allEmails = data?.emails;
    let allPhones = data?.phones;

    state.contactIsTypes.forEach((t) => {
      let filtered = allContacts.filter(function (el) {
        return el.is_type == t;
      });
      let contact = filtered[0];
      if (contact) {
        if (!contact?.email_address) {
          let filteredEmails = allEmails.filter((el) => el.is_type === t);
          if (filteredEmails?.length > 0) {
            contact['email_address'] = filteredEmails[0];
          }
        }
        if (!contact?.phone) {
          let filteredPhones = allPhones.filter((el) => el.is_type === t);
          if (filteredPhones?.length > 0) {
            contact['phone'] = filteredPhones[0];
          }
        }
        commit('setSavedContact', { data: contact, is_type: t });
      }
    });
    dispatch('checkRequiredComplete');
  },

  async checkRequiredComplete({ state, commit }) {
    if (
      state.savedContacts?.dispatch &&
      state.savedContacts?.billing &&
      state.savedContacts?.claims
    ) {
      commit('setRequiredContactsCompleted', true);
    }
  },

  async createOrUpdateContact({ dispatch, commit }, data) {
    let method = data?.method;
    let payload = data?.payload;
    let body = {
      contact: payload,
    };

    // console.log('payload');
    // console.dir(payload);

    switch (method) {
      case 'post':
        try {
          let res = await axios.post(
            process.env.API_MONITOR + '/api/v1/contacts/',
            body
          );
          if (res && res?.data) {
            commit('setSavedContact', {
              data: res?.data,
              is_type: res?.data?.is_type,
            });
          }
          dispatch('checkRequiredComplete');
          return res;
        } catch (e) {
          let status = e?.response?.status;
          if (
            axios.isAxiosError(e) &&
            status &&
            [401, 403, 404, 422].includes(status)
          ) {
            return e?.response;
          } else {
            throw e;
          }
        }
      case 'patch':
        try {
          let res = await axios.patch(
            process.env.API_MONITOR + '/api/v1/contacts/' + payload['id'],
            body
          );
          if (res && res?.data) {
            commit('setSavedContact', {
              data: res?.data,
              is_type: res?.data?.is_type,
            });
          }
          return res;
        } catch (e) {
          let status = e?.response?.status;
          if (
            axios.isAxiosError(e) &&
            status &&
            [401, 403, 404, 422].includes(status)
          ) {
            return e?.response;
          } else {
            throw e;
          }
        }
    }
  },
  async removeSavedContactByType({ state, commit }, type) {
    commit('deleteSavedContactByType', type);
    if (state.requiredContactIsTypes.includes(type)) {
      commit('setRequiredContactsCompleted', false);
    }
  },
  async deleteContactById(_, id) {
    try {
      let res = await axios.delete(
        process.env.API_MONITOR + '/api/v1/contacts/' + id
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setSavedContact(state, { data, is_type }) {
    switch (is_type) {
      case 'dispatch':
        state.savedContacts.dispatch = data;
        break;
      case 'billing':
        state.savedContacts.billing = data;
        break;
      case 'claims':
        state.savedContacts.claims = data;
        break;
      case 'after_hours':
        state.savedContacts.after_hours = data;
        break;
      case 'emergency':
        state.savedContacts.emergency = data;
        break;
      case 'owner':
        state.savedContacts.owner = data;
        break;
    }
  },
  setNameError(state, el) {
    state.errors.name = el;
  },
  setPhoneError(state, el) {
    state.errors.phone = el;
  },
  setEmailError(state, el) {
    state.errors.email = el;
  },
  resetErrors(state) {
    state.errors.name = false;
    state.errors.email = false;
    state.errors.phone = false;
  },
  setRequiredContactsCompleted(state, bool) {
    state.requiredContactsCompleted = bool;
  },
  deleteSavedContactByType(state, is_type) {
    state.savedContacts[is_type] = null;
  },
  setContacts(state, contacts) {
    state.contacts = contacts;
  },
  setAllContacts(state, { data, is_type }) {
    switch (is_type) {
      case 'dispatch':
        state.dispatch_contacts = data;
        break;
      case 'billing':
        state.billing_contacts = data;
        break;
      case 'claims':
        state.claims_contacts = data;
        break;
      case 'after_hours':
        state.after_hours_contacts = data;
        break;
      case 'emergency':
        state.emergency_contacts = data;
        break;
      case 'owner':
        state.owner_contacts = data;
        break;
    }
  },
  setContactsLoading(state, bool) {
    state.isContactsLoading = bool;
  },
  setContactTypeLoading(state, { bool, type }) {
    state.contactsLoading[type] = bool;
  },
  setContactsPagination(state, { data, type }) {
    state.contactsPagination[type] = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
